import axios from "axios";
import {setStorage,getAuthHeader} from '../config/Utils';


export const loginUser=async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/login`
    return axios.post(url,body).then((res)=>{
        if (res.data.status) {
            setStorage("token", res.data.data.token);
            setStorage("userDetail", res.data.data);
        }
        return res.data
    })
}


export const autoLoginUser=async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/auto-login`
    return axios.post(url,body,getAuthHeader()).then((res)=>{
        if (res.data.status) {
            sessionStorage.clear()
            setStorage("token", res.data.data.token);
            setStorage("userDetail", res.data.data);
        }
        return res.data
    }) 
    
}